import React from 'react';
import { getDifficultyConfig } from '../../utils/difficultyManager';

const DifficultyBadge = ({ difficulty, onClick, showLabel = true }) => {
  const config = getDifficultyConfig(difficulty);

  return (
    <div 
      className={`difficulty-badge ${onClick ? 'clickable' : ''}`}
      onClick={onClick}
      style={{ 
        background: config.color,
        cursor: onClick ? 'pointer' : 'default'
      }}
      title={`${config.name} - ${config.label}`}
    >
      <span className="difficulty-badge-icon">{config.icon}</span>
      {showLabel && (
        <span className="difficulty-badge-text">{config.name}</span>
      )}
    </div>
  );
};

export default DifficultyBadge;
